<script lang="ts">
  // Sample ancestor tree. Inverted from the genealogy convention:
  // YOU at the top, parents fanning DOWN. Per Mike's spec —
  // "starts from the user and goes vertically downwards, expanding from parents."
  export let rows = 4;
</script>

<svg viewBox="0 0 400 220" class="mini" aria-hidden="true">
  <defs>
    <linearGradient id="mg" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0" stop-color="#c11c39"/>
      <stop offset="1" stop-color="#bf8a40"/>
    </linearGradient>
  </defs>
  <!-- edges (you at top → parents → grandparents → great-grandparents) -->
  <g stroke="#b9a98c" stroke-width=".8" fill="none" stroke-linecap="square" opacity=".95">
    <path d="M200 20 L200 60"/>
    <path d="M200 60 L120 90 L120 120 M200 60 L280 90 L280 120"/>
    {#if rows >= 4}
      <path d="M120 120 L70 150 L70 180 M120 120 L170 150 L170 180 M280 120 L230 150 L230 180 M280 120 L330 150 L330 180"/>
    {/if}
  </g>
  <!-- you (root) at top -->
  <rect x="194" y="14" width="12" height="12" fill="url(#mg)"/>
  <!-- parents -->
  <rect x="194" y="54" width="12" height="12" fill="#bf8a40"/>
  <!-- grandparents -->
  <rect x="114" y="114" width="12" height="12" fill="#d8ccb6"/>
  <rect x="274" y="114" width="12" height="12" fill="#d8ccb6"/>
  <!-- great-grandparents -->
  {#if rows >= 4}
    <rect x="64"  y="174" width="12" height="12" fill="#efe7d4"/>
    <rect x="164" y="174" width="12" height="12" fill="#efe7d4"/>
    <rect x="224" y="174" width="12" height="12" fill="#efe7d4"/>
    <rect x="324" y="174" width="12" height="12" fill="#efe7d4"/>
  {/if}
</svg>

<style>
  .mini { width: 100%; height: auto; display: block; }
</style>
